<template>
  <div class="artice-container">
    <div class="banner-container">
      <div class="banner-content">
        <div class="banner-title">新闻中心</div>
        <div class="banner-info">了解优图最新动态</div>
      </div>
    </div>
    <div class="news-content-panel">
      <div class="news-title">腾讯优图应用场景多样化 践行科技向善服务更多社会群体</div>
      <div class="news-content">
        <p>
          腾讯公司旗下顶级人工智能实验室。 聚焦计算机视觉：专注人脸识别、图像识别、OCR等领域开展技术研发和行业落地。推动产业升级：始终专注基础研究、产业落地两条腿走路的战略，助力行业降本增效。践行科技向善：致力于通过视觉 AI 技术解决社会问题，帮助社会群体。
        </p>
        <div class="news-p-title">应用场景：</div>
        <p>AI+工业制造：优图通过工业视觉AI平台，我们提供从数据采集、标注、训练、评测、推理的全流程功能，针对不同技术背景的用户画像，提供不同的训练方案，让客户能自主训练与迭代属于自己的模型；已经为3C、半导体、航空制造、烟草等领域的客户提供定制的解决方案。</p>
        <p>AI+医疗应用：腾讯觅影是腾讯公司首款将人工智能技术运用在医学领域的AI 产品，利用AI 医学影像分析，克服疲劳对人工诊断的影响，提高准确率。觅影的成功应用使患者获得更有效地治疗，更早的对癌症患者进行筛查。</p>
        <p>AI+泛互应用：疫情期间，我们的人脸核身技术支持了北京、上海等全国多地的健康码的核身过程，此外，通过开放平台为140多个行业，为政府机构与企业提供核身服务。</p>
        <p>AI+金融保险：在金融保险方面，我们的AI识别算法通过100多种设备形态落地如商场、超市、学校、医药等大量场景，为社会各界带来便利的支付体验。通过端云的协同识别，让用户感受到秒级刷脸的体验。通过精准的3D人脸识别，我们保障暗光等困难场景下，刷脸持续可以使用。</p>
        <p>AI+娱乐社交：孵化30+项泛娱乐能力助力社交应用、短视频直播、游戏影业、互动营销等泛娱乐行业升级。</p>
        <div class="news-p-title">所获荣誉：</div>
        <p>2021年10月 ，ICCV2021 LVIS Challenge Workshop冠军及最佳创新奖</p>
        <p>2021年8月， CVPR2021 Image Matching Workshop 新纪录</p>
        <p>2021年4月， NTIRE 视频空间超分和时空超分双赛道冠亚军</p>
        <p>2020年9月， 深圳人工智能展获颁 AI Star 奖项</p>
        <p>2020年6月， 开源移动端推理框架 TNN</p>
        <p>2019年4月，DSFD算法开源</p>
        <p>2017年11月，车辆追踪准确率在KITTI中刷新世界纪录</p>
        <p>2017年4月，人脸识别MegaFace刷新世界纪录</p>
        <p>2017年3月，人脸识别LFW刷新世界纪录</p>
        <p>2017年3月，OCR文本检测在ICDAR2015“Robust Reading Competition”排名第一</p>
        <p>2015年，音频识别在MIREX比赛世界第一</p>
        <p>2015年，人脸识别在LFW刷新世界纪录</p>
        <p>2015年，图像理解在ImageNet定位比赛国内第3</p>
        <p>2015年，图像分类在Pascal VOC2012刷新世界纪录</p>
        <p> 2014年，人脸检测刷新FDDB世界纪录</p>
      </div>
    </div>
    <div class="app-footer">
      <div class="app-footer-right">
        <div class="app-footer-right-left">
          <div class="app-footer-right-title">腾讯优图，你身边的视觉AI专家</div>
        </div>
        <div class="app-footer-right-text">Copyright © 1998-{{(new Date()).getFullYear()}} Tencent. All Rights Reserved.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Article'
};
</script>

<style lang="less" scoped>
@container-min-width: 1263px;
.artice-container{
  width: 100%;
  background-color: #ffffff;
  div{
    box-sizing: border-box;
  }
  .banner-container{
    width: 100%;
    color: #ffffff;
    background-image: url(./img/banner_news.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    .banner-content{
      width: @container-min-width;
      height: 360px;
      padding-left: 30px;
      margin: 0 auto;
      .banner-title{
        font-size: 40px;
        font-family: 'PingFangSC-Medium';
        color: #000000;
        font-weight: 500;
        padding-top: 125px;
      }
      .banner-info{
        height: 32px;
        font-size: 18px;
        color: #3D485D;
        line-height: 32px;
        margin-top: 10px;
      }
    }
  }
  .news-content-panel {
    width: 1263px;
    margin: 0 auto;
    padding: 50px 30px 120px;
    color: #3D485D;
    .news-title {
      height: 48px;
      font-family: 'PingFangSC-Semibold';
      font-size: 28px;
      color: #000000;
      text-align: center;
      line-height: 48px;
      font-weight: 600;
      margin-bottom: 50px;
    }
    .news-content {
      font-size: 16px;
      p {
        line-height: 28.8px;
        padding: 8px 0;
      }
      a {
        text-decoration: underline;
        font-size: 16px;
        color: #0080FF;
      }
      .news-p-title {
        height: 30px;
        font-family: 'PingFangSC-Semibold';
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        font-weight: 600;
        margin-top: 40px;
        margin-bottom: 12px;
      }
      .news-note {
        height: 20px;
        opacity: 0.6;
        font-size: 14px;
        line-height: 20px;
      }
      .image-panel {
        width: 780px;
        margin: 40px auto;
        .news-image {
          width: 780px;
        }
        .image-caption {
          opacity: 0.8;
          font-size: 14px;
          text-align: center;
        }
      }
    }
  }
  .app-footer {
    width: @container-min-width;
    margin: 0 auto;
    color: #3D485D;
    .app-footer-right {
      margin: 0 30px;
      height: 50px;
      font-size: 12px;
      position: relative;
      border-top: 1px solid #D2D7DF;
      padding-top: 20px;
      .app-footer-right-left {
        background: url("./img/logo_youtu.svg") top left no-repeat;
        background-size: 70px 20px;
        .app-footer-right-title {
          display: inline-block;
          margin-left: 80px;
          letter-spacing: 6px;
          text-align: justify;
          line-height: 20px;
          padding-left: 10px;
          border-left: 1px solid #D2D7DF;
        }
      }
      .app-footer-right-text {
        height: 20px;
        text-align: center;
        line-height: 20px;
        position: absolute;
        right: 0;
        top: 20px;
      }
    }
  } 
}
</style>



// WEBPACK FOOTER //
// src/components/article/Article.vue